import { useNavigate, useRouter } from '@tanstack/react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { twMerge } from 'tailwind-merge';
import messages from './messages';

const BackButton = ({
  onClick,
  className,
}: {
  onClick?: Function;
  className?: string;
}) => {
  const router = useRouter();
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const backMessages = messages[language];

  return (
    <button
      type="button"
      className={twMerge(
        `absolute lg:fixed mt-2 ml-6 text-2xl lg:mt-2 lg:-ml-4 lg:text-base left-0 top-0 lg:top-auto lg:left-auto z-40 text-header-text focus:outline-none font-semibold`,
        className,
      )}
      onClick={() => (onClick ? onClick() : router.history.back())}>
      <span className="block lg:hidden">
        {backMessages.backButtonTextMobile}
      </span>
      <span className="hidden lg:block py-4">
        {backMessages.backButtonText}
      </span>
    </button>
  );
};

export default BackButton;
